export const isFieldsEqual = <O, P extends keyof O>(props1: O, props2: O, fields: readonly P[]) => {
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    if (props1[field] !== props2[field]) return false;
  }
  return true;
}
